// Local product data - no database required
export const PRODUCTS = [
  {
    id: "prod-laser-1",
    name: "HP LaserJet Pro MFP M428fdw",
    category: "Laser Printer",
    brand: "HP",
    description: "Professional multifunction laser printer with fast print speeds, duplex printing, and wireless connectivity. Perfect for small offices and workgroups.",
    price: 32999,
    stock: 15,
    image_url: "https://images.unsplash.com/photo-1612815154858-60aa4c59eaa6",
    created_at: "2025-01-15T10:00:00"
  },
  {
    id: "prod-laser-2",
    name: "Canon imageCLASS LBP6230dw",
    category: "Laser Printer",
    brand: "Canon",
    description: "Compact wireless laser printer with automatic duplex printing. Ideal for home offices and personal use with high-quality output.",
    price: 18999,
    stock: 22,
    image_url: "https://images.unsplash.com/photo-1650094980833-7373de26feb6",
    created_at: "2025-01-15T10:05:00"
  },
  {
    id: "prod-laser-3",
    name: "Brother HL-L2395DW",
    category: "Laser Printer",
    brand: "Brother",
    description: "Reliable monochrome laser printer with automatic two-sided printing and wireless networking. Great value for home and small office.",
    price: 15499,
    stock: 18,
    image_url: "https://images.unsplash.com/photo-1571845995697-28be270350de",
    created_at: "2025-01-15T10:10:00"
  },
  {
    id: "prod-laser-4",
    name: "Samsung Xpress M2835DW",
    category: "Laser Printer",
    brand: "Samsung",
    description: "Fast and efficient laser printer with NFC and Wi-Fi Direct. Easy mobile printing with excellent print quality.",
    price: 12999,
    stock: 20,
    image_url: "https://images.pexels.com/photos/7639358/pexels-photo-7639358.jpeg",
    created_at: "2025-01-15T10:15:00"
  },
  {
    id: "prod-inkjet-1",
    name: "Canon PIXMA G3010",
    category: "Inkjet Printer",
    brand: "Canon",
    description: "All-in-one ink tank printer with high page yield. Perfect for home use with wireless connectivity and mobile printing support.",
    price: 11500,
    stock: 25,
    image_url: "https://images.unsplash.com/photo-1708793699492-5fa208f52dcb",
    created_at: "2025-01-15T10:20:00"
  },
  {
    id: "prod-inkjet-2",
    name: "Epson EcoTank L3250",
    category: "Inkjet Printer",
    brand: "Epson",
    description: "Cartridge-free printing with easy-to-fill ink tanks. High volume printing at low cost with Wi-Fi connectivity.",
    price: 13999,
    stock: 30,
    image_url: "https://images.unsplash.com/photo-1706895040634-62055892cbbb",
    created_at: "2025-01-15T10:25:00"
  },
  {
    id: "prod-inkjet-3",
    name: "HP DeskJet 2755e",
    category: "Inkjet Printer",
    brand: "HP",
    description: "Compact all-in-one inkjet printer with wireless printing. Easy setup and use for everyday printing needs.",
    price: 7999,
    stock: 35,
    image_url: "https://images.unsplash.com/photo-1715059448930-9dff21725605",
    created_at: "2025-01-15T10:30:00"
  },
  {
    id: "prod-cart-1",
    name: "HP 680 Black Ink Cartridge",
    category: "Ink Cartridge",
    brand: "HP",
    description: "Original HP ink cartridge for consistent, reliable performance. Compatible with HP DeskJet series.",
    price: 599,
    stock: 100,
    image_url: "https://images.unsplash.com/photo-1625585832695-25214fe33618",
    created_at: "2025-01-15T10:35:00"
  },
  {
    id: "prod-cart-2",
    name: "Canon PG-47 Black Cartridge",
    category: "Ink Cartridge",
    brand: "Canon",
    description: "Genuine Canon ink cartridge delivering sharp, clear text. Compatible with Canon PIXMA printers.",
    price: 675,
    stock: 85,
    image_url: "https://images.unsplash.com/photo-1733749843877-ddf6ab6b8923",
    created_at: "2025-01-15T10:40:00"
  },
  {
    id: "prod-cart-3",
    name: "Epson 003 Color Cartridge Set",
    category: "Ink Cartridge",
    brand: "Epson",
    description: "Complete set of cyan, magenta, and yellow ink cartridges. High-quality prints with vibrant colors.",
    price: 1299,
    stock: 60,
    image_url: "https://images.unsplash.com/photo-1625585832695-25214fe33618",
    created_at: "2025-01-15T10:45:00"
  },
  {
    id: "prod-bottle-1",
    name: "HP GT51 Black Ink Bottle",
    category: "Ink Bottle",
    brand: "HP",
    description: "High capacity ink bottle for HP Smart Tank printers. Up to 6,000 pages of crisp black text.",
    price: 499,
    stock: 120,
    image_url: "https://images.unsplash.com/photo-1583162557635-53d9931332c5",
    created_at: "2025-01-15T10:50:00"
  },
  {
    id: "prod-bottle-2",
    name: "Canon GI-790 Cyan Ink Bottle",
    category: "Ink Bottle",
    brand: "Canon",
    description: "Original Canon ink bottle for PIXMA G series. High page yield with brilliant color reproduction.",
    price: 385,
    stock: 95,
    image_url: "https://images.unsplash.com/photo-1719361888629-0d73d1c1bf8f",
    created_at: "2025-01-15T10:55:00"
  },
  {
    id: "prod-bottle-3",
    name: "Epson T6641 Black Ink Bottle",
    category: "Ink Bottle",
    brand: "Epson",
    description: "Ultra high capacity black ink for Epson L-series printers. Up to 4,000 pages per bottle.",
    price: 450,
    stock: 110,
    image_url: "https://images.pexels.com/photos/6593420/pexels-photo-6593420.jpeg",
    created_at: "2025-01-15T11:00:00"
  },
  {
    id: "prod-bottle-4",
    name: "Brother BT5000 Ink Bottle Set",
    category: "Ink Bottle",
    brand: "Brother",
    description: "Complete CMYK ink bottle set for Brother DCP and MFC series. High yield and excellent value.",
    price: 1850,
    stock: 45,
    image_url: "https://images.pexels.com/photos/4348363/pexels-photo-4348363.jpeg",
    created_at: "2025-01-15T11:05:00"
  }
];

export const CATEGORIES = [
  { id: "laser-printer", name: "Laser Printer" },
  { id: "inkjet-printer", name: "Inkjet Printer" },
  { id: "ink-cartridge", name: "Ink Cartridge" },
  { id: "ink-bottle", name: "Ink Bottle" }
];

// Helper functions
export const getProducts = (category = null) => {
  if (category) {
    return PRODUCTS.filter(p => p.category === category);
  }
  return PRODUCTS;
};

export const getProductById = (id) => {
  return PRODUCTS.find(p => p.id === id);
};

export const getCategories = () => {
  return CATEGORIES;
};
